import { render } from "./PetPosterModal.vue?vue&type=template&id=689a8022&scoped=true&ts=true"
import script from "./PetPosterModal.vue?vue&type=script&lang=ts"
export * from "./PetPosterModal.vue?vue&type=script&lang=ts"

import "./PetPosterModal.vue?vue&type=style&index=0&id=689a8022&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689a8022"]])

export default __exports__